import { Directive } from '@angular/core';
import { provideQuestionImageBucketName } from '@examdojo/question-image';

@Directive({
  selector: '[dojoMarkschemeImageBucket]',
  standalone: true,
  providers: [provideQuestionImageBucketName('markscheme-images')],
})
export class MarkschemeImageBucketDirective {}
